'use client'

export default function GlobalClientEffect() {
    return null
}
